import React, { Component } from 'react';

import FleximodoParkinglocationsSelect from './FleximodoParkinglocationsSelect';

import { Form, Input, Button, Modal, InputNumber, Select } from 'antd';
const FormItem = Form.Item;
class FleximodoSensorsForm extends Component {

  state = {
    modalVisible: false,
    disabled: true
  }

  form = null;

  componentWillReceiveProps(nextProps) {
    this.setState({
      modalVisible: nextProps.modalVisible
    });
  }

  handleTypeChange = e => {
    if (e == 'U-Spot') {
      this.setState({
        disabled: false
      });
    } else {
      this.setState({
        disabled: true
      });
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.onSuccess(this.props.form, values);
        this.props.onModalCancel(this.props.form);
      }
    });
  }

  renderForm() {
    const { disabled } = this.state;
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
        <FormItem
          {...formItemLayout}
          label="Lokalita">
          {getFieldDecorator('locationId', {
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <FleximodoParkinglocationsSelect onChange={(value) => { this.props.form.setFieldsValue({ locationID: value }); }} />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Sériové číslo">
          {getFieldDecorator('serialNumber', {
            rules: [{
              type: 'string', message: 'Položka musí být string!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <Input />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Místo" >
          {getFieldDecorator('slotNumber', { initialValue: 0 },
            {
            })(
              <InputNumber min={0} max={999999} initialValue={0} />
            )}
        </FormItem>
        <FormItem {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit">Vložit</Button>
        </FormItem>
      </Form>
    );
  }

  render() {
    if (this.props.type && this.props.type === 'modal') {
      return (
        <Modal
          width={650}
          title="Vytvoření nového senzoru"
          visible={this.state.modalVisible}
          onCancel={() => {
            this.props.onModalCancel(this.props.form);
            this.setState({ modalVisible: false });
          }}
          footer={<p></p>}>
          {this.renderForm()}
        </Modal>
      )
    } else {
      return this.renderForm();
    }
  }
}

const WrappedInfrastructuresForm = Form.create()(FleximodoSensorsForm);

export default WrappedInfrastructuresForm;


// WEBPACK FOOTER //
// ./src/components/FleximodoSensorsForm.js